import React from 'react';
const links = ['Contatti', 'Privacy Policy', 'Termini di servizio', 'Assistenza'];
export function Footer() {
  return <footer className="w-full border-t border-cream-300 bg-cream-100 px-4 py-12" data-id="element-58" data-mp="3gg118925080a">
      <div className="mx-auto max-w-3xl text-center" data-id="element-59" data-mp="32onkt3zizq9h">
        <p className="font-display text-[15px] font-black uppercase tracking-[0.16em] text-ink" data-id="element-60" data-mp="32m1awxp5wyo3">
          Scienze Pronta™
        </p>

        <nav aria-label="Link legali" className="mt-5" data-id="element-61" data-mp="3ueih5klswg7n">
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-62" data-mp="3ucxmzw3eezab">
            {links.map(link => <li key={link} data-id="element-63" data-mp="3lem127dh8po7">
                <a href="#offerta" className="font-sans text-[11px] text-ink-muted transition-colors duration-150 ease-out hover:text-brand" data-id="element-64" data-mp="3ldanjfu8c3jw">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>

        <p className="mt-6 font-sans text-[10.5px] leading-relaxed text-ink-muted" data-id="element-65" data-mp="2ezba1zojva52">
          © 2026 Scienze Pronta™. Tutti i diritti riservati. Materiale didattico non affiliato al
          Ministero dell&apos;Istruzione.
        </p>
      </div>
    </footer>;
}